'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = require('jbone');

var _jbone2 = _interopRequireDefault(_jbone);

var _view = require('./core/view');

var _view2 = _interopRequireDefault(_view);

var _ui = require('./ui.scss');

var _ui2 = _interopRequireDefault(_ui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlayerUIView = function (_View) {
  _inherits(PlayerUIView, _View);

  function PlayerUIView(config) {
    _classCallCheck(this, PlayerUIView);

    var _this = _possibleConstructorReturn(this, (PlayerUIView.__proto__ || Object.getPrototypeOf(PlayerUIView)).call(this, config));

    var width = config.width,
        height = config.height,
        callbacks = config.callbacks;


    _this._inFullScreen = false;

    _this._callbacks = callbacks;

    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['video-wrapper'],
      'data-hook': 'player-container'
    });

    _this.$innerWrapper = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['inner-wrapper']
    });

    _this.setWidth(width);
    _this.setHeight(height);

    _this.$node.append(_this.$innerWrapper);

    _this._bindCallbacks();

    _this._bindEvents();
    return _this;
  }

  _createClass(PlayerUIView, [{
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._proxyMouseEnterOnNode = this._proxyMouseEnterOnNode.bind(this);
      this._proxyMouseMoveOnNode = this._proxyMouseMoveOnNode.bind(this);
      this._proxyMouseLeaveOnNode = this._proxyMouseLeaveOnNode.bind(this);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this.$node[0].addEventListener('mouseenter', this._proxyMouseEnterOnNode);
      this.$node[0].addEventListener('mousemove', this._proxyMouseMoveOnNode);
      this.$node[0].addEventListener('mouseleave', this._proxyMouseLeaveOnNode);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.$node[0].removeEventListener('mouseenter', this._proxyMouseEnterOnNode);
      this.$node[0].removeEventListener('mousemove', this._proxyMouseMoveOnNode);
      this.$node[0].removeEventListener('mouseleave', this._proxyMouseLeaveOnNode);
    }
  }, {
    key: '_proxyMouseEnterOnNode',
    value: function _proxyMouseEnterOnNode() {
      this._callbacks.onMouseEnter();
    }
  }, {
    key: '_proxyMouseMoveOnNode',
    value: function _proxyMouseMoveOnNode() {
      this._callbacks.onMouseMove();
    }
  }, {
    key: '_proxyMouseLeaveOnNode',
    value: function _proxyMouseLeaveOnNode() {
      this._callbacks.onMouseLeave();
    }
  }, {
    key: 'setWidth',
    value: function setWidth(width) {
      if (!width) {
        return;
      }

      this._width = width;

      this.$node.css({
        width: this._width + 'px'
      });
    }
  }, {
    key: 'setHeight',
    value: function setHeight(height) {
      if (!height) {
        return;
      }

      this._height = height;

      this.$node.css({
        height: this._height + 'px'
      });
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'appendComponentNode',
    value: function appendComponentNode(node) {
      this.$innerWrapper.append(node);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'setFullScreenStatus',
    value: function setFullScreenStatus(isFullScreen) {
      if (isFullScreen) {
        this.$node.attr('data-in-full-screen', true);
      } else {
        this.$node.removeAttr('data-in-full-screen');
      }
      this.$node.toggleClass(this.styleNames['full-screen'], isFullScreen);
      this._inFullScreen = isFullScreen;
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.$node.remove();

      delete this.$node;
    }
  }]);

  return PlayerUIView;
}(_view2.default);

PlayerUIView.extendStyleNames(_ui2.default);

exports.default = PlayerUIView;
//# sourceMappingURL=ui.view.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/ui.view.js
// module id = 1706
// module chunks = 1 2 3